import config from "../../config";

const STORAGE_KEY = "user_permissions";

/**
 * Permisos personalizados por usuario (tabla user_permission del backend).
 * Sin filas guardadas, el usuario conserva el menu de su rol. Con filas,
 * su menu y navegacion se construyen solo con las rutas con can_view.
 * canEdit(path) permite a cada pantalla ocultar acciones de edicion.
 */
class PermissionsService {
  getUser = () => {
    try {
      return JSON.parse(localStorage.getItem("auth_user")) || {};
    } catch (error) {
      return {};
    }
  };

  getCached = () => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (error) {
      return [];
    }
  };

  setCached = (permissions) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(permissions || []));
  };

  clear = () => {
    localStorage.removeItem(STORAGE_KEY);
  };

  refresh = async () => {
    try {
      const response = await config.get("permissions/me");
      const permissions = Array.isArray(response.data) ? response.data : [];
      this.setCached(permissions);
      return permissions;
    } catch (error) {
      return this.getCached();
    }
  };

  hasCustomPermissions = () => {
    const user = this.getUser();
    if (user.rol_user === "admin") return false;
    return this.getCached().length > 0;
  };

  findRow = (path) => this.getCached().find((p) => p.path === path);

  canView = (path) => {
    if (!this.hasCustomPermissions()) return true;
    const row = this.findRow(path);
    // Rutas internas (detalles, edicion con :id) no estan en el catalogo
    // del menu y no se bloquean; solo se controlan las rutas registradas.
    if (!row) return true;
    return Number(row.can_view) === 1;
  };

  canEdit = (path) => {
    if (!this.hasCustomPermissions()) return true;
    const row = this.findRow(path);
    if (!row) return true;
    return Number(row.can_edit) === 1;
  };
}

export default new PermissionsService();
